import { Component, OnInit } from "@angular/core";
import { TagModule } from "primeng/tag";
import { GetYearOverYearReportTilesCount } from "../../../core/models/dashboard/getYearOverYearReportTilesCount";
import { GenericResponseDto } from "../../../core/models/generic-response.dto";
import { ValidateLogin } from "../../../core/models/validate-login.dto";
import { DashboardService } from "../../../core/services/dashboard.service";
import { ProfileFormService } from "../../../core/services/profile-form.service";
import { UserRole } from "../../enums/userRoles.enum";
import { UserManagementService } from "../../../core/services/user-management.service";
import { CommonModule } from "@angular/common";

@Component({
  selector: "jni-header-tags",
  imports: [TagModule, CommonModule],
  templateUrl: "./header-tags.component.html",
  styleUrl: "./header-tags.component.scss",
})
export class HeaderTagsComponent implements OnInit {
  public cardClass = ["order", "ledger", "invoice"];
  cardList = [
    {
      colorCode: "green-tag",
      cardTitle: "YTD GP $0 GP% 0",
      cardValue: 0,
    },
    {
      colorCode: "sky-tag",
      cardTitle: "CDI's",
      cardValue: 0,
    },
    {
      colorCode: "gray-tag",
      cardTitle: "Invoice Preview",
      cardValue: 0,
    },
    {
      colorCode: "fer-tag",
      cardTitle: "Pending Chargebacks",
      cardValue: 0,
    },
    {
      colorCode: "sky2-tag",
      cardTitle: "Disputed Invoices",
      cardValue: 0,
    },
    {
      colorCode: "darkgray-tag",
      cardTitle: "Expiring Protection",
      cardValue: 0,
    },
  ];
  expiringDaysCount = 0;
  cdiCount = 0;
  invoicePreviewCount = 0;
  chargebackCount = 0;
  totalOutstanding = 0;
  clientStatus = "";
  userRole = 0;
  loggedInUserIsAdmin = false;
  loggedInUserIsBC = false;
  getYearOverYearReportTilesCount: GetYearOverYearReportTilesCount =
    {} as GetYearOverYearReportTilesCount;

  constructor(
    private _dashboardService: DashboardService,
    private _profileFormService: ProfileFormService,
    private _loginService: UserManagementService
  ) {}

  ngOnInit(): void {
    this.getUserProfile();
    this.getUnprotectedCustomersCount();
    this.getPendingCharges();
    this.getInvoiceProposalsCount();
    this.getCDICount();
    this.getDisputedInvoiceCount();
    this.getYearOverYearSummaryCount();
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userRole = res.data.userRoleId;
        if (this.userRole === UserRole.Admin) {
          this.loggedInUserIsAdmin = true;
        } else {
          this.getUserById(res?.data?.userId);
        }
      });
  }

  getUserById(userId: number) {
    this._profileFormService.getUsersById(userId).subscribe({
      next: res => {
        if (res?.data) {
          if (res?.data?.isLedgerActive === true) {
            this.loggedInUserIsBC = true;
          }

          //YTD tile only show when user is BC or Admin
          if (
            this.loggedInUserIsAdmin !== true &&
            this.loggedInUserIsBC !== true
          ) {
            this.cardList = this.cardList.filter(
              x => !x.cardTitle.includes("YTD GP")
            );
          }
        }
      },
    });
  }

  getUnprotectedCustomersCount() {
    this._dashboardService.getUnprotectedCustomersCount().subscribe({
      next: res => {
        if (res) {
          this.cardList.find(
            x => x.cardTitle === "Expiring Protection"
          )!.cardValue = res.data;
        }
      },
      error: () => {
        this.cardList.find(
          x => x.cardTitle === "Expiring Protection"
        )!.cardValue = 0;
      },
    });
  }

  getPendingCharges() {
    this._dashboardService.getPendingCharges().subscribe({
      next: res => {
        if (res) {
          this.cardList.find(
            x => x.cardTitle === "Pending Chargebacks"
          )!.cardValue = res.data;
        }
      },
      error: () => {
        this.cardList.find(
          x => x.cardTitle === "Pending Chargebacks"
        )!.cardValue = 0;
      },
    });
  }

  getInvoiceProposalsCount() {
    this._dashboardService.getInvoiceProposalsCount().subscribe({
      next: res => {
        if (res) {
          this.cardList.find(
            x => x.cardTitle === "Invoice Preview"
          )!.cardValue = res.data;
        }
      },
      error: () => {
        this.cardList.find(x => x.cardTitle === "Invoice Preview")!.cardValue =
          0;
      },
    });
  }

  getCDICount() {
    this._dashboardService.getCDICount().subscribe({
      next: res => {
        if (res) {
          this.cardList.find(x => x.cardTitle === "CDI's")!.cardValue =
            res.data;
        }
      },
      error: () => {
        this.cardList.find(x => x.cardTitle === "CDI's")!.cardValue = 0;
      },
    });
  }

  redirectToSummaryPage(cardTitle: string) {
    if (cardTitle === "Expiring Protection") {
      this.clientStatus = "active";
      const url = "clients/expiring-days/1";
      window.open(url, "_blank");
    } else if (cardTitle === "Pending Chargebacks") {
      const url = "dashboard/quadreport1";
      window.open(url, "_blank");
    } else if (cardTitle === "Invoice Preview") {
      const url = "invoice-preview";
      window.open(url, "_blank");
    } else if (cardTitle === `CDI's`) {
      const url = "cdi";
      window.open(url, "_blank");
    } else if (cardTitle === "Disputed Invoices") {
      /* eslint-disable @typescript-eslint/no-explicit-any */
      const url = "reports/customer-aging-detail-report";
      (window as any).sourcePage = "dashboard";
      window.open(url, "_blank");
      /* eslint-enable @typescript-eslint/no-explicit-any */
    } else if (cardTitle.includes("YTD GP")) {
      const url = "reports/year-over-year";
      window.open(url, "_blank");
    }
  }

  getDisputedInvoiceCount() {
    this._dashboardService.getDisputedInvoicesCount().subscribe({
      next: res => {
        if (res) {
          this.cardList.find(
            x => x.cardTitle === "Disputed Invoices"
          )!.cardValue = res.data;
        }
      },
      error: () => {
        this.cardList.find(
          x => x.cardTitle === "Disputed Invoices"
        )!.cardValue = 0;
      },
    });
  }

  setStyleWidth() {
    if (this.cardList.findIndex(x => x.cardTitle.includes("YTD GP")) != -1) {
      return "width: 16.6%;";
    } else {
      return "width: 20%";
    }
  }

  getYearOverYearSummaryCount() {
    this._dashboardService.getYearOverYearSummaryCount().subscribe({
      next: res => {
        if (res?.data) {
          this.getYearOverYearReportTilesCount = res.data;
          const ytdCard = this.cardList.find(x =>
            x.cardTitle.includes("YTD GP")
          );
          if (ytdCard) {
            ytdCard.cardTitle = `YTD GP $${this.numberWithCommas(Number((res?.data?.gpAmountTotal ?? 0).toFixed(2)))}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;GP% ${Number((res?.data?.gpPercentageTotal ?? 0).toFixed(2))}`;
          }
        }
      },
      error: () => {
        // Fix: Use .includes() instead of exact match, and only reset YTD GP card
        const ytdCard = this.cardList.find(x => x.cardTitle.includes("YTD GP"));
        if (ytdCard) {
          ytdCard.cardValue = 0;
        }
      },
    });
  }

  numberWithCommas(value: number) {
    if (value) {
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    } else {
      return "";
    }
  }
}
